import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ImpactStep from "../../molecules/impactStep/ImpactStep";
import CostStep from "../../molecules/costStep/CostStep";
import ReportStep from "../../molecules/reportStep/ReportStep";
import "./NewAnalysisSidebar.css";
import { IMPACTS_TABS } from "../../../conts/navigationConstants";
import { DEFAULT_UNIT_VALUES, newResource } from "../../../conts/simulationConstants";

const NewAnalysisSidebar = ({
  realPolygon,
  simPolygon,
  onDraw,
  onImport,
  onSelectHistoric,
  onClose,
  onLaunchAnalysis,
  impacts,
  onLaunchCost,
  cost,
  onLaunchReport,
  report,
    onReset,

}) => {
  const [reportType, setReportType] = useState("complete");

  const handleGenerate = () => {
    onLaunchReport(reportType);
    goTo(2);
  };
  const [step, setStep] = useState(0);
  const [unitValues, setUnitValues] = useState(DEFAULT_UNIT_VALUES);

  const [resources, setResources] = useState([
    newResource("terrestre"),
    newResource("aérien"),
    newResource("humain"),
  ]);
  // a step is reachable only once the previous one produced results
  // (adjust `cost?.data` if your cost object exposes results under another key)
  const hasImpacts = Boolean(impacts?.data?.results);
  const hasCost = Boolean(cost?.data);

  const stepEnabled = [
    true, // Impacts: always available
    hasImpacts, // Coût des sauvés: needs impact results
    hasImpacts && hasCost, // Rapport: needs impact + cost results
  ];

  const lockedReason = [
    "",
    "Lancez d’abord l’analyse d’impact",
    hasImpacts
      ? "Lancez d’abord le calcul du coût des sauvés"
      : "Lancez d’abord l’analyse d’impact",
  ];

  // if results disappear (new run, reset...), never stay on a locked step
  useEffect(() => {
    if (!stepEnabled[step]) {
      const lastAllowed = stepEnabled.lastIndexOf(true);
      setStep(Math.max(0, lastAllowed));
    }
  }, [hasImpacts, hasCost]); // eslint-disable-line react-hooks/exhaustive-deps

  const goTo = (i) => {
    if (stepEnabled[i]) setStep(i);
  };

  return (
    <aside className="analysis-sidebar">
      <div className="analysis-sidebar__header">
        <nav
          className="analysis-sidebar__stepper"
          aria-label="Étapes de l’analyse"
        >
          {IMPACTS_TABS.map((label, i) => {
            const enabled = stepEnabled[i];
            return (
              <button
                key={label}
                type="button"
                className={`analysis-sidebar__step ${i === step ? "is-active" : ""} ${i < step ? "is-done" : ""}`}
                aria-current={i === step ? "step" : undefined}
                disabled={!enabled}
                title={enabled ? undefined : lockedReason[i]}
                onClick={() => goTo(i)}
              >
                <span className="analysis-sidebar__num">
                  {enabled ? i + 1 : <LockOutlinedIcon sx={{ fontSize: 13 }} />}
                </span>
                {label}
              </button>
            );
          })}
        </nav>

        <IconButton
          onClick={onClose}
          size="small"
          aria-label="Fermer le panneau d'analyse"
          sx={{ color: "var(--color-burgundy)", flexShrink: 0 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {step === 0 && (
        <ImpactStep
          onNext={() => goTo(1)}
          realPolygon={realPolygon}
          simPolygon={simPolygon}
          onDraw={onDraw}
          onImport={onImport}
          onSelectHistoric={onSelectHistoric}
          onLaunchAnalysis={onLaunchAnalysis}
          impacts={impacts}
          onReset={onReset}
        />
      )}
      {step === 1 && (
        <CostStep
          onBack={() => setStep(0)}
          canContinue={stepEnabled[2]}
          onLaunchCost={onLaunchCost}
          cost={cost}
          unitValues={unitValues}
          setUnitValues={setUnitValues}
          resources={resources}
          setResources={setResources}
          onNext={handleGenerate}
          reportType={reportType}
          setReportType={setReportType}
        />
      )}
      {step === 2 && (
        <ReportStep
          onBack={() => setStep(1)}
          report={report}
          reportType={reportType}
          onRetry={() => onLaunchReport(reportType)}
        />
      )}
    </aside>
  );
};

export default NewAnalysisSidebar;
